import { MediaTrackerFn } from '@rhg/hooks/use-media-tracker/types';
import { SxProps, Theme } from '@rhg/libs/material';
import { ReactNode } from 'react';
import { PlayerAudio } from '../types';
import { ControlButtonType } from '../video-player/types';

export enum AudioPlayerControls {
    Regular = 'regular',
    Playlist = 'playlist',
    Soundscape = 'soundscape',
    Infinite = 'infinite',
}

export enum AudioPlayerVariant {
    Expanded = 'expanded',
    Collapsed = 'collapsed',
    Minimal = 'minimal',
}

export enum AudioTimelineVariant {
    Large = 'large',
    Small = 'small',
    Minimal = 'minimal',
}

export interface AudioPlayerProps {
    audio: PlayerAudio;
    title?: string;
    subtitle?: string;
    image?: ReactNode;
    controls?: AudioPlayerControls;
    variant?: AudioPlayerVariant;
    customAction?: ReactNode;
    drawerTitleIcon?: ReactNode;
    autoplay?: boolean;
    loop?: boolean;
    previousProgress?: number;
    isInitiallyMuted?: boolean;
    isFloating?: boolean;
    willTrackProgress?: boolean;
    trackFn?: MediaTrackerFn;
    onClose?: () => void;
    controlsSx?: SxProps<Theme>;
    sx?: SxProps<Theme>;
    onNextTrack?: () => void;
    onPreviousTrack?: () => void;
    areControlsHidden?: boolean;
    onControlClick?: (buttonType: ControlButtonType) => void;
}

export interface AudioControlsProps {
    controls?: AudioPlayerControls;
    variant?: Exclude<AudioPlayerVariant, AudioPlayerVariant.Minimal>;
    isFloating?: boolean;
    title?: string;
    subtitle?: string;
    image?: ReactNode;
    customAction?: ReactNode;
    onStop?: () => void;
    controlsSx?: SxProps<Theme>;
    sx?: SxProps<Theme>;
    onNextTrack?: () => void;
    onPreviousTrack?: () => void;
    areControlsHidden?: boolean;
    onControlClick?: (buttonType: ControlButtonType) => void;
    drawerTitleIcon?: ReactNode;
}

export interface AudioMinimalControlsProps {
    onStop?: () => void;
    title?: string;
    subtitle?: string;
    image?: ReactNode;
    isFloating?: boolean;
    controlsSx?: SxProps<Theme>;
    sx?: SxProps<Theme>;
    controls?: AudioPlayerControls;
    areControlsHidden?: boolean;
    onControlClick?: (buttonType: ControlButtonType) => void;
}
